import axios from '@/libs/api.request'
import {genURLParams} from '@/libs/urlparamhelper';

export const getPage = (params, urlParams) => {
  return axios.request({
    url: '/history/locatehistory/' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getByLocationDatetime = (params, urlParams) => {
  return axios.request({
    url: '/history/locatehistory/getbylocationdatetime/' + params.terminalNum + '/' + params.startDatetime + '/' + params.endDatetime + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const loadTrack = (params, urlParams) => {
  return axios.request({
    url: '/history/locatehistory/loadtrack/' + params.mongoTripId + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const loadDailyTrack = (params, urlParams) => {
  return axios.request({
    url: '/history/locatehistory/loaddailytrack/' + params.terminalNum + '/' + params.selectDatetime + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const removeBefore = (params, urlParams) => {
  return axios.request({
    url: '/history/locatehistory/removebefore/' + params.selectDatetime + '' + genURLParams(urlParams),
    method: 'DELETE',
    credentials: 'include',
    data: params
  })
}

